const API_HOST = 'https://studio.freevideoeditor.online'
const API_DEV_HOST = 'https://smarteditingonline.solveigmm.com' // see http://18.184.210.86/issues/5603#note-3


const API_USER_INFO_URL = '/api/users/me'
const API_USERS = '/api/users'
const API_TOKENS_URL = '/api/tokens'
const API_DEV_PROFILES = '/api/dev_profiles'
const API_VERSION = '/api/version'

const AUTHORIZATION_HOST_URL = 'https://freevideoeditor.online/signin'
//const AUTHORIZATION_HOST_URL = 'http://smm.com:3000'

const LS_PRODUCT_NAME = 've_online_api'
const LS_PRODUCT_DATA = 'Full'

const LS_HOST_URL = 'https://www.solveigmm.com/ls'
//const LS_HOST_URL = 'http://smm.com:3000'

const LS_API_GEN_KEY = '/api/gen_key'
const LS_API_KEYS = '/api/keys'
const LS_API_KEY_RESTRICTIONS = '/api/key_restrictions'

export const checkTokenExpired = token => {
    return fetch(`${API_HOST}${API_TOKENS_URL}/${token}`, {
        method: 'GET',
    })
}

export const getUserInfo = async token => {
    try {
        const response = await fetch(`${API_HOST}${API_USER_INFO_URL}`, {
            method: 'GET',
            headers: {
                Authorization: token,
            }
        })
        return await response.json()
    } catch (e) {
        throw Error(`getUserInfo error: ${e}`)
    }
}
export const getDevProfile = async apiKey => {
    try {
        const response = await fetch(`${API_HOST}${API_DEV_PROFILES}/${apiKey}`, {
            method: 'GET',
            headers: {
                Authorization: apiKey,
            }
        })
        return await response.json()
    } catch (e) {
        throw Error(`getDevProfile error: ${e}`)
    }
}

export const updateDevProfile = (apiKey, data) => {
    return fetch(`${API_HOST}${API_DEV_PROFILES}/${apiKey}`, {
        method: 'PATCH',
        headers: {
            Authorization: apiKey,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
}
export const getBackendVersion = async () => {
  try {
    const response = await fetch(`${API_HOST}${API_VERSION}`, {
      method: 'GET',
    })
    const verData =  await response.json()
    return verData.version
  } catch (e) {
    throw Error(`getBackendVersion error: ${e}`)
  }
}


export const getOrCreateTryUserSession = async (apiKey, secreteAPIKey) => {
    const id = `dashboard${apiKey}`
    let response = await fetch(`${API_HOST}${API_USERS}/${id}`, {
        method: 'GET',
    })
    if (!response.ok) {
        response = await fetch(`${API_HOST}${API_USERS}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id, name: 'TrySession', apiKey, secreteAPIKey }),
        })
        if (!response.ok) {
            throw Error(`createUserSession error`)
        }
    } else {
        response = await fetch(`${API_HOST}${API_USERS}/${id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ name: 'TrySession', apiKey, secreteAPIKey }),
        })
        if (!response.ok) {
            throw Error(`updateUserSession error`)
        }
    }

    response = await fetch(`${API_HOST}${API_TOKENS_URL}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId: id }),
    })
    if (!response.ok) {
        throw Error(`createUserToken error`)
    }
    const tokenData =  await response.json()
    return tokenData.token
}

export const getEditoryCustomizeViewURL = token => {
    const state = btoa(JSON.stringify({ customizeView: true }))
    return `${API_HOST}/projects/new?auth_token=${token}&state=${encodeURIComponent(state)}`
}

export const getUserSessionURL = id => {
    return `${API_DEV_HOST}/projects/new?auth_token=${id}`
}

// LS Server api

export const signUpRedirect = async () => {
  try {
    const state = btoa(JSON.stringify({}))
    const redirectUrl = `${window.location.origin}${window.location.pathname}?state=${state}`
    const productVersion = await getBackendVersion()
    window.location.href = `${AUTHORIZATION_HOST_URL}?productName=${LS_PRODUCT_NAME}&productVersion=${productVersion}&redirect_uri=${encodeURIComponent(redirectUrl)}`
  } catch (e) {
    console.error(`signUpRedirect error:${e}`)
  }
}

export const genSecreteAPIKey = async token => {
 try {
    const version = await getBackendVersion()
    const response = await fetch(`${LS_HOST_URL}${LS_API_GEN_KEY}`, {
      method: 'POST',
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
        },
        body: JSON.stringify({ product: LS_PRODUCT_NAME, version, data: LS_PRODUCT_DATA }),
    })
    const data =  await response.json()
    return data.key
  } catch (e) {
    throw Error(`genSecreteKey error: ${e}`)
  }
}

export const getSecreteAPIKey = async token => {
  try {
    const version = await getBackendVersion()
    const response = await fetch(`${LS_HOST_URL}${LS_API_KEYS}?product=${LS_PRODUCT_NAME}&version=${version}`, {
      method: 'GET',
      headers: {
        Authorization: token,
      }
    })
    const data =  await response.json()
    return data.keys?.length ? data.keys[0].key : null
  } catch (e) {
    throw Error(`getSecreteAPIKey error: ${e}`)
  }
}

export const getAvalableTaskTokens = async (token, key) => {
  try {
    const response = await fetch(`${LS_HOST_URL}${LS_API_KEY_RESTRICTIONS}?key=${key}`, {
      method: 'GET',
      headers: {
        Authorization: token,
      }
    })
    const data =  await response.json()
    return data.taskTokens
  } catch (e) {
    throw Error(`getAvalableTokens error: ${e}`)
  }
}